// extracted by mini-css-extract-plugin
module.exports = {"block-skeleton":"block-skeleton_block-skeleton__byDyo"};